<div class="auth-fluid bg-cover bg-repeat-no">
    <div class="auth-fluid-form-box">
        <div class="align-items-center d-flex h-100">
            <div class="card-body">
                <div class="auth-brand text-center text-lg-left">
                    <a href="index.html" class="logo-dark">
                        <span><img src="assets/images/logo-AA.png" alt="" height="24"></span>
                    </a>
                </div>
                <div class="m-auto">
                    <h4 class="text-dark-50 mt-4 font-weight-bold">Password Setup</h4>
                </div>
                <form class="form-group mb-0" [formGroup]="resetPassForm" (ngSubmit)="resetPassword()">
                    <div class="form-group">
                        <label for="password">New Password</label>
                        <div class="input-group input-group-merge">
                            <input class="form-control" formControlName="password" [type]="typePassword" id="password" placeholder="Enter new password">
                            <div class="input-group-append" (click)="changeTypePassword()" id="changeType">
                                <div class="input-group-text">
                                    @if (typePassword=='text') {
                                        <span class="uil uil-eye"></span>
                                    }
                                    @if (typePassword!='text') {
                                        <span class="uil uil-eye-slash"></span>
                                    }
                                </div>
                            </div>
                        </div>
                        @if ((password.invalid && password.dirty)) {
                            <span class="text-danger">Password Invalid: Must contain at least 8 characters, uppercase, lowercase, numbers and special characters (* -$%)</span>
                        }
                        @if ((password.invalid && password.dirty)) {
                        <span class="text-danger">Password is required.</span>
                        }
                    </div>
                    <div class="form-group">
                        <label for="password">Confirm Password</label>
                        <input class="form-control" formControlName="confirmPassword" [type]="typePassword" id="confirm-password" placeholder="Confirm password">
                        @if ((confirmPassword.invalid && confirmPassword.dirty)) {
                            <span class="text-danger">Confirm password is required</span>
                        }
                    </div>
                    @for (errors of resetPassForm.errors | keyvalue; track errors) {
                        <span class="text-danger">{{errors.value}}</span>
                    }
                    <button [disabled]="loading || resetPassForm.invalid" class="btn btn-primary btn-block">
                        @if (loading) {
                            <img src="../../../assets/images/loading.svg" alt="" height="20">
                        }
                        Reset Password</button>
                    <p class="mt-2 text-center">
                        Back to
                        <button [routerLink]="['/login']" class="ml-0 border-0 bg-transparent text-primary"><b>Sign
                                In</b></button>
                    </p>
                </form>
            </div> <!-- end .card-body -->
        </div> <!-- end .align-items-center.d-flex.h-100-->
    </div>
    <!-- end auth-fluid-form-box-->

    <!-- Auth fluid right content -->
    <div class="auth-fluid-right text-center">
        <div class="auth-user-testimonial">
            <h1 class="mb-3">Welcome </h1>
            <p class="lead ">Build Your Dealership On A Solid Foundation with RockIT DMS.</p>
            <footer class="footer-alt p-1 d-flex align-items-end justify-content-between">
                <p class="text-muted mb-0">2020 Rock IT DMS</p>
                <div class="d-flex">
                    <p class="text-muted mx-2 mb-0">Privacy </p>
                    <p class="text-muted mx-2 mb-0">Legal</p>
                    <p class="text-muted mx-2 mb-0">Contact</p>
                </div>
            </footer>
        </div> <!-- end auth-user-testimonial-->
    </div>
    <!-- end Auth fluid right content -->
</div>